import React from 'react'
import OptionalsBox from "../../../frontend/CarDetails/OptionalsBox"

export default class EditOptionals extends React.Component {
    constructor(props) {
        super(props)
    }

    submitSearch = () => {
         const r = this.optionals.selectedValues()
        window.location.href = '/admin/reservations/'+this.props.res_id+'/update_optionals?' + '&o=' + r
    }

    render() {
        return(
            <div className={'row'}>
                <div className={'col'}>
                    <OptionalsBox {...this.props} ref={(optionals) => this.optionals = optionals} edit={true}/>
                    <div className={'pull-right mt-4'}>
                    <button className={'btn btn-success'} onClick={this.submitSearch}>{this.props.t.save}</button>
                    </div>
                </div>
            </div>
        )
    }
}